<template>
    <div class="vh-100 success-container pt-3">
        <div class="header mb-5">
            <div class="header">
                <div class="col align-self-center">
                    <Logo/>
                </div>
            </div>
        </div>
        <h1 class="mb-5 text-center">{{title}}</h1>
        <h2 class="text-center">{{message}}</h2>
    </div>
</template>

<script>
    import Logo from '../components/Logo';
    import DateInput from "../components/DateInput";
    import PhoneInput from "../components/PhoneInput";
    import PinCodeInput from "vue-pincode-input";
    import BirthdayModal from "../components/BirthdayModal";
    import LimitErrorModal from "../components/LimitErrorModal";

    const email = {
        title: 'На вашу пошту надіслано посилання для відновлення пароля',
        message: '',
    }
    const registration = {
        title: 'Ви успішно зареєструвалися !',
        message: 'Відкрийте ваш мобільний додаток та виконайте вхід',
    }
    const reset_password = {
        title: 'Пароль оновлено !',
        message: '',
    }
    const confirm_email = {
        title: 'Пошта успішно підтверджена !',
        message: '',
    }
    export default {
        name: "SuccessPage",
        props: {
            type: {
                required: true,
                type: String,
            },
        },
        components: {
            Logo,
        },
        data() {
            return {
                title: '',
                message: '',
            }
        },
        mounted() {
            switch (this.type) {
                case 'email':
                    let email = this.$route.query.email
                    if (email){
                      this.title = `На пошту ${email} надіслано посилання для відновлення пароля`
                    }
                    else{
                      this.title = email.title
                    }
                    this.message = email.message
                    break;
                case 'registration':
                    this.title = registration.title
                    this.message = registration.message
                    this.redirectToMobile()
                    break;
                case 'reset_password':
                    this.title = reset_password.title
                    this.message = reset_password.message
                    break;
                case 'confirm_email':
                    this.title = confirm_email.title
                    this.message = confirm_email.message
                    break;
            }
        },
        methods: {
            redirectToMobile() {
                setTimeout(() => {
                    window.open('OdrexClient://successRegistration', '_blank')
                }, 3000)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/utils/variables";

    .success-container {
        background: $bg-color;
    }

    @media (max-width: 475px) {
        .success-container {
            h1 {
                font-size: 2rem;
            }

            h2 {
                font-size: 1.5rem;
            }
        }
    }
</style>
